import "./index.css";
import "./App.css";

import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "redux/store";

import { createRoot } from "react-dom/client";
import App from "app/App";

// import reportWebVitals from './reportWebVitals';

const container = document.getElementById("root");
const root = createRoot(container as HTMLElement); // createRoot(container!) if you use TypeScript
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
